import { AgentSchema, ApiKeychainSchema } from "../../../../utils/types";
import { InfoBox } from "../../../../components/info/InfoBox";

import { KeychainSecrets } from "./KeychainSecrets";

import "./AgentsKeychain.scss";

export function AgentsKeychain({
  agent,
  onAgentUpdated,
  apiKeychain
}: {
  agent?: AgentSchema,
  onAgentUpdated?: (agent: AgentSchema) => void,
  apiKeychain?: ApiKeychainSchema,
}) {

  apiKeychain = (apiKeychain || agent?.apiKeychain) as ApiKeychainSchema;
  const onApiKeychainUpdated = (apiKeychain: ApiKeychainSchema) => {
    if (agent) {
      agent.apiKeychain = apiKeychain;
      onAgentUpdated?.(agent);
    }
  };

  return (
    <div data-component="AgentsKeychain">
      <div className="keychain-primer">
        <InfoBox>
          {agent?.apiKeychain && (<>Secrets stored here are used to authenticate your agent with third-party services.<br /></>)}
          {!agent?.apiKeychain && (<>This <strong>test keychain</strong> allows you to set sample secrets for your package without an agent.<br /></>)}
          They can be accessed in package code via <code>context.keychain.key("KEY_NAME")</code>
        </InfoBox>
      </div>
      <KeychainSecrets
        apiKeychain={apiKeychain}
        onApiKeychainUpdated={onApiKeychainUpdated}
      />
    </div>
  );
}